<owc-breadcrumb #breadcrumbElement class="custom-breadcrumb">
    <owc-breadcrumb-item 
        [routerLink]="['/']" 
        [hyperlinkProps]="{target:'_self'}" 
        (click)="$event.preventDefault();" data-testid="app-breadcrumb-btn">
            <owc-typography  variant="badge">
                {{dashboard}}
            </owc-typography>
    </owc-breadcrumb-item>
    <owc-breadcrumb-item 
        *ngFor="let breadcrumb of breadcrumbs; let index = index,let last = last;" 
        [url]="breadcrumb.url"
        [hyperlinkProps]="{target:'_self'}" 
        (click)="$event.preventDefault();navigate(breadcrumb);"  [attr.data-testid]="'app-breadcrumb-prevent-default-btn-' + ($any(breadcrumb)?.id || $any(breadcrumb)?.name || $any(breadcrumb)?.key || $any(breadcrumb)?.value || $any(breadcrumb)?.code || index)">
        <span *ngIf="!last"> 
            <owc-typography variant="badge">
                {{breadcrumb.label}}
            </owc-typography>
        </span>
        <span *ngIf="last"> 
            <owc-typography variant="caption">
                {{breadcrumb.label}}
            </owc-typography>
        </span>
    </owc-breadcrumb-item>
</owc-breadcrumb>